export default {
	dataIterator: {
		rowsPerPageText: 'Risultati per pagina',
		rowsPerPageAll: 'Tutti',
		pageText: '{0}-{1} di {2}',
		noResultsText: 'Nessun Risultato',
		nextPage: 'Prossima pagina',
		prevPage: 'Pagina precedente'
	},
	dataTable: {
		rowsPerPageText: 'Risultati per pagina'
	},
	noDataText: 'Nessun risultato'
}
